import { useEffect, useState } from "react";
import "./styles/Modals.css";
import Teleport from "../Custom/Teleport";
import { Alert, Box, Button, Checkbox, IconButton } from "@mui/material";
import { AddCircleRounded, Delete, Remove } from "@mui/icons-material";
import TextAreaField from "../Custom/TextAreaField";
import { getQuestionById } from "../../endpoints/Assessment/functions";
import { trashStyles } from "../../context/customStyles";
import CustomTextField from "../Custom/CustomTextField";
import CustomDropDown from "../Custom/CustomDropDown";
const ModifyQuestion = (props) => {
  const [error, setError] = useState("");
  const [question, setQuestion] = useState({
    exam_id: props.examId,
    question: "",
    question_type: "MC",
  });
  const [choices, setChoices] = useState([
    { choice: "", position: 1, correct: false },
    { choice: "", position: 2, correct: false },
  ]);
  function toggleChecks(selectedIndex, value) {
    setChoices(
      choices.map((item, index) => {
        if (index === selectedIndex) {
          return { ...item, correct: value };
        }

        if (question.question_type === "MC") {
          return { ...item, correct: false };
        }

        return item;
      }),
    );
    props.setChangesMade({ ...props.changesMade, questions: true });
  }

  useEffect(() => {
    if (
      props.questionId &&
      props.open === "active" &&
      props.questionIndex === null
    ) {
      const fetchData = async () => {
        const res = await getQuestionById(props.questionId, props.token);
        setQuestion({
          id: res.id,
          exam_id: res.exam.id,
          question: res.question,
          question_type: res.question_type,
        });
        setChoices(res.choices);
      };
      fetchData();
    } else if (props.questionIndex !== null && props.open === "active") {
      setQuestion(props.questions[props.questionIndex]);
      setChoices(props.questions[props.questionIndex].choices || []);
    } else {
      setQuestion({
        exam_id: props.examId,
        question: "",
        question_type: "MC",
      });
      setChoices([
        { choice: "", position: 1, correct: false },
        { choice: "", position: 2, correct: false },
      ]);
    }
  }, [
    props.open,
    props.questionId,
    props.examId,
    props.questionIndex,
    props.questions,
    props.token,
  ]);

  useEffect(() => {
    if (
      error &&
      question.question &&
      choices.find((choice) => choice.correct) &&
      !choices.some((choice) => !choice.choice) &&
      choices.length === new Set(choices.map((choice) => choice.choice)).size
    ) {
      setError("");
    }
  }, [error, question, choices]);

  function handleClose() {
    props.setOpen("");
    props.setQuestionId(null);
    props.setIndex(null);
    setError("");
  }

  function validated() {
    let errorMessage = "";
    if (!question.question) {
      errorMessage = "A question is required. ";
    }
    if (!choices.find((choice) => choice.correct)) {
      errorMessage += "One correct choice needs to be selected. ";
    }
    if (choices.some((choice) => !choice.choice)) {
      errorMessage += "All choices are required.";
    }
    if (
      choices.length !== new Set(choices.map((choice) => choice.choice)).size
    ) {
      errorMessage += "Choices must be unique.";
    }
    if (errorMessage) {
      setError(errorMessage);
      return false;
    }

    setError("");
    return true;
  }

  function addChoice() {
    if (choices.length >= 2) {
      setChoices([
        ...choices,
        {
          choice: "",
          position: choices.length + 1,
          correct: false,
        },
      ]);
    }
  }

  function removeChoice(selectedChoice) {
    const newChoices = choices.filter((choice) => choice !== selectedChoice);
    if (choices.length > 2) {
      setChoices(newChoices);
    }
  }
  function handleAddQuestion() {
    if (validated()) {
      if (props.questionIndex === null) {
        props.setQuestions((prevQuestions) => {
          const newQuestions = [...prevQuestions];
          newQuestions.push({ ...question, choices, add: true });
          return newQuestions;
        });
      } else {
        props.setQuestions((prevQuestions) => {
          const newQuestions = [...prevQuestions];
          newQuestions[props.questionIndex] = {
            ...question,
            exam_id: props.examId,
            choices,
            add: true,
          };
          return newQuestions;
        });
      }
      props.setChangesMade({ ...props.changesMade, questions: true });
      handleClose();
    }
  }

  function handleDeleteQuestion() {
    if (props.questionId) {
      props.setQuestions((prevQuestions) => {
        const newQuestions = [...prevQuestions];
        newQuestions[props.questionIndex].delete = true;
        return newQuestions;
      });
    } else {
      props.setQuestions((prevQuestions) => {
        const newQuestions = [...prevQuestions];
        newQuestions.splice(props.questionIndex, 1);
        return newQuestions;
      });
    }
    props.setChangesMade({ ...props.changesMade, questions: true });
    handleClose();
  }

  function handleEditQuestion() {
    if (validated()) {
      props.setQuestions((prevQuestions) => {
        const newQuestions = [...prevQuestions];
        newQuestions[props.questionIndex] = {
          ...question,
          question: question.question,
          question_type: question.question_type,
          choices,
          edit: true,
        };
        return newQuestions;
      });
      props.setChangesMade({ ...props.changesMade, questions: true });
      handleClose();
    }
  }

  function setNewQuestionValue(value) {
    setQuestion({
      ...question,
      question: value,
    });
  }

  function handleTypeChange(event) {
    const newType = event.target.value;

    setQuestion((prev) => ({
      ...prev,
      question_type: newType,
    }));
    if (newType === "MC") {
      setChoices((prev) => prev.map((item) => ({ ...item, correct: false })));
    }
    props.setChangesMade({ ...props.changesMade, questions: true });
  }
  return (
    <Teleport>
      <div className={props.open} id="choice-modal">
        <div className="header">
          <h1>
            {props.questionIndex !== null ? "Edit Question" : "Add Question"}
          </h1>
          {props.questionIndex !== null && (
            <IconButton
              style={trashStyles}
              color="error"
              className="icon-button"
              onClick={handleDeleteQuestion}
            >
              <Delete fontSize="inherit" color="error" />
            </IconButton>
          )}
        </div>
        <div className="modal-body">
          {!!error && (
            <Alert severity="error" type="error" variant="filled">
              {error}
            </Alert>
          )}
          <div className="w-100">
            <h4 className="italic-subtitle">
              <div>Question Details</div>
            </h4>
            <div className="spaced-content">
              <TextAreaField
                label="Question *"
                value={question.question}
                data={question}
                error={!!error && !question.question}
                setQuestion={setNewQuestionValue}
              />
              <CustomDropDown
                label="Question Type"
                color="black"
                fullWidth
                required
                value={question.question_type}
                onChange={handleTypeChange}
                options={[
                  {
                    label: "Multiple Choice",
                    value: "MC",
                  },
                  {
                    label: "Multi-Select",
                    value: "MS",
                  },
                ]}
              />
            </div>
          </div>
          <div className="w-100">
            <h4 className="italic-subtitle">
              <div>Choices</div>
              <Button
                color="ghostBlue"
                variant="contained"
                disabled={choices.length === 5}
                className="py-1"
                startIcon={<AddCircleRounded color="inherit" />}
                disableElevation
                onClick={addChoice}
              >
                Add Choice
              </Button>
            </h4>
            <div className="choices">
              {choices.map((choice, index) => {
                return (
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "2px" }}
                    key={`choice-${choice.position}`}
                  >
                    <Checkbox
                      checked={choice.correct}
                      size="small"
                      title="Correct Answer"
                      color={
                        !!error && !choices.find((choice) => choice.correct)
                          ? "error"
                          : "black"
                      }
                      slotProps={{
                        input: {
                          onKeyDown: (e) => {
                            if (e.key === "Enter") {
                              toggleChecks(index, !choice.correct);
                            }
                          },
                        },
                      }}
                      onChange={(e) => toggleChecks(index, e.target.checked)}
                    />
                    <CustomTextField
                      fullWidth
                      required
                      color="black"
                      label={`Choice ${index + 1}`}
                      className="choice"
                      value={choice.choice}
                      error={!!error && !choice.choice}
                      inputProps={{ maxLength: 250 }}
                      InputProps={{
                        endAdornment: choices.length > 2 && (
                          <IconButton
                            size="small"
                            onClick={() => removeChoice(choice)}
                          >
                            <Remove fontSize="inherit" color="error" />
                          </IconButton>
                        ),
                      }}
                      onChange={(e) => {
                        setChoices((prevChoices) => {
                          const newChoices = [...prevChoices];
                          newChoices[index].choice = e.target.value;
                          return newChoices;
                        });
                      }}
                    />
                  </Box>
                );
              })}
            </div>
            <div className="float-actions gap-2 d-flex justify-content-center pt-3">
              <Button
                onClick={() => handleClose()}
                color="ghostBlack"
                variant="contained"
                className="py-2"
                sx={{ maxWidth: "8rem", width: "100%" }}
                disableElevation
              >
                Cancel
              </Button>
              <Button
                color="black"
                variant="contained"
                disableElevation
                className="py-2"
                sx={{ maxWidth: "8rem", width: "100%" }}
                onClick={
                  props.questionId && question.id
                    ? handleEditQuestion
                    : handleAddQuestion
                }
              >
                {props.questionIndex !== null ? "Save" : "Add"}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={props.open} id="choice-overlay"></div>
    </Teleport>
  );
};
export default ModifyQuestion;
